import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { SortDirection } from '../../config/settingConfig'
import FileContext, { FileListItemDto } from '../../context/FileContext'
import { FileStatus } from '../../config/fileConfig'
import GlobalContext from '../../context/GlobalContext'
import BaseCombobox, { SubComboboxProps } from './BaseCombobox'

export type FileComboboxProps = SubComboboxProps<FileListItemDto> & {
    idProp?: string
    includeArchived?: boolean
    initialValues?: string[]
}

export default function FileCombobox(props: FileComboboxProps): ReactElement {
    const { files } = useContext(FileContext)
    const { settings } = useContext(GlobalContext)
    const [sortedFiles, setSortedFiles] = useState<FileListItemDto[]>([])

    useEffect(() => {
        if (files.loaded) {
            const fileSort = settings?.fileSort
            const asc: boolean = fileSort?.direction === SortDirection.Ascending
            setSortedFiles(
                files.data.sort(
                    (a, b) =>
                        (a[fileSort?.field] || a.reference).toLocaleString().localeCompare((b[fileSort?.field] || b.reference).toLocaleString()) *
                        (asc ? 1 : -1),
                ),
            )
        }
    }, [files])

    return (
        <BaseCombobox<FileListItemDto>
            entities={sortedFiles}
            filter={(entity: FileListItemDto) =>
                props.includeArchived || props.initialValues?.some(id => id === entity.id) || entity.status === FileStatus.Open
            }
            getEntityLabel={(entity: FileListItemDto) =>
                settings?.fileSort?.field === 'name' ? `${entity.name} (${entity.reference})` : `${entity.reference} - ${entity.name}`
            }
            getEntityValue={(entity: FileListItemDto) => entity[props.idProp] || entity.id}
            getEntitySearchValue={(entity: FileListItemDto) => entity.normalizedName}
            placeholderKey={'base.filepicker.placeholder'}
            {...props}
        />
    )
}
